// Porta do módulo (U06): outro módulo, a casca e as rotas só importam daqui. Fixtures e handlers ficam
// em `testing.ts` (X02); as telas entram por `loadCreditNoteScreens` (import dinâmico, fora do JS inicial).
export {
  CREDIT_NOTE_DATASETS,
  getCreditNote,
  listCreditNotes,
  type CreditNoteListFilters,
  type CreditNoteListParams,
  type DatasetRecordType,
} from './credit-note.api';
export { loadCreditNoteMessages } from './credit-note.catalog';
export { CREDIT_NOTE_TABS, creditNoteDetailContext, creditNoteDetailScreen, creditNoteDetailSearch, type CreditNoteTab } from './credit-note-detail.screen';
export { CREDIT_NOTE_LIST_PATH, creditNoteListContext, creditNoteListScreen } from './credit-note-list.screen';
export { creditNoteListSearch } from './credit-note-list.search';
export { creditNoteFilters } from './credit-note.filters';
export {
  creditNoteDetailQuery,
  creditNoteKeys,
  creditNoteListQuery,
  datasetQuery,
  useCreditNoteMutation,
  type CreditNoteMutationName,
} from './credit-note.queries';
export { legacyBankAccountLabel } from './credit-note.legacy-format';
export { CREDIT_NOTE_STATUS } from './credit-note.status';
export {
  DETAIL_ACTIONS,
  LIST_ACTIONS,
  productFacts,
  recordFacts,
  visibleDetailActions,
  visibleListActions,
  type ActionBarModel,
  type DetailActionContext,
  type ListActionContext,
  type VisibleAction,
} from './credit-note.status-actions';
export { CREDIT_NOTE_STATUSES, creditNoteSchema, creditNoteStatusSchema, type CreditNote, type CreditNoteStatus } from './credit-note.wire';

// Os carregadores de tela moram no `route.ts` (porta das rotas): pela porta pública, `person` fechava um ciclo até o detalhe.

// Ações de registro de pessoa que o legado compartilha com a operação (unidade 6A, `person`): os campos e os
// corpos de "Compartilhar registro" (`ShareRecord`), "Adicionar token consignado" (`ReserveToken`) e "Remover
// restrições" (`DeleteCheckList`), e as restrições de compliance do tomador. Uma cópia só (lite §1).
export { personComplianceRestrictionsQuery } from './credit-note.queries';
export type { ComplianceChecklistItem } from './credit-note.wire';
export { RESTRICTION_LABELS } from './screens/bar-options';
export { reserveTokenBody, shareSchema, tokenRowsSchema, type ShareValues, type TokenRow } from './screens/bar-bodies';
export { CheckboxListField, ShareFields, TokenRowsField } from './screens/bar-fields';
export { useDefinitionRunner } from './screens/agent-runner';

// Dados bancários da pessoa (unidade 10E, `person`): as opções e os valores do `BankDetails` do legado
// (pages/BankAccount/BankDetailsTab), que a revisão da conta transitória já usa. Uma cópia só (lite §1).
export {
  bankDetailsDefaults,
  clearedForOperation,
  NATURAL_ACCOUNT_TYPES,
  OPERATION_TYPES,
  PIX,
  PIX_AGENCY_AND_ACCOUNT,
  PIX_KEY_TYPES,
  TRANSFER,
  type BankDetailsValues,
  type LiquidationOption,
} from './credit-note.liquidation';

// Aba Crédito por pessoa (R2): "Limite de Crédito", "Consultar margem - SIAPE" e "Consultar margem - ZETRA" do
// `CreditTabContainer`, que o legado usa igual na Operação e em Pessoas. Sob demanda: a porta continua leve.
export const loadCreditNoteCreditPanels = () => import('./screens/credit-tab-panels');

// Consulta de margem para a Simulação (R4, R5; onda 4 do Fluxo guiado): as consultas em fases do Crédito do
// Trabalhador e do Zetra com a máquina de fases e o fio num lugar só (a Simulação dá as entradas e recebe a escolha por
// `onApply`), o painel em fases e os cartões das margens.
export { type MarginWrite } from './credit-note.margin';
export { MarginCards, MarginPanel, type MarginCardOption } from './screens/margin-panel';
export { DataprevMarginSheet } from './screens/margin-dataprev';
export { ZetraMarginSheet, type ZetraDeadlines } from './screens/margin-zetra';

// Margem INSS (R5): o quadro "Consultar consignado INSS" do MarginQueryFormContainer (`isConsignadoInss`), o mesmo na
// Operação e na Simulação. Sob demanda, para a porta continuar leve.
export const loadCreditNoteInssMargin = () => import('./screens/margin-inss');
export type { InssMarginApply } from './screens/margin-inss';

// Consignação para compra (R5): o painel da 10H sem o formulário da operação (`onApply`), para a Simulação (Zetra).
export const loadCreditNoteConsignment = () => import('./screens/margin-consignment');
export { consignmentProduct, type ConsignmentProduct, type ConsignmentWrite } from './credit-note.consignment';

// "Atualizar margem" da Zetra sem tomador (`UpdateZetra`, R5): o mesmo na Operação e na Simulação, sob demanda.
export const loadCreditNoteZetraUpdate = () => import('./screens/margin-zetra-update');
export { requestZetraMarginUpdate, type ZetraUpdateToken } from './credit-note.margin';
export { scheduleItemFromForm, scheduleFormDefaults, scheduleItemSchema, clearedForTransaction, pixAgencyTransfer, PIX_AGENCY, SCHEDULE_ACCOUNT_TYPES, SCHEDULE_PIX_KEY_TYPES, TRANSACTION_TYPES, type ScheduleFormValues } from './credit-note.bank-account';
export { MASKED_PIX_KEYS } from './credit-note.liquidation';
export { BANKS_ALL } from './screens/liquidation-fields';
